import { createStore } from '../core/store.ts';

/**
 * Мягкие подсказки: «осталось 2», «товар закончился».
 *
 * Это не ошибки: человек продолжает делать то, что делал, плашка гаснет сама. Одинаковый текст
 * подряд не дублируется: остаток сверяется на каждое нажатие «плюс».
 */
export type Toast = { id: number; text: string };

export const toastsStore = createStore<Toast[]>([]);

const LIFETIME_MS = 3_000;
let nextId = 1;

export function notify(text: string): void {
  if (toastsStore.get().some((item) => item.text === text)) return;
  const id = nextId++;
  toastsStore.set((items) => [...items, { id, text }]);
  setTimeout(() => toastsStore.set((items) => items.filter((item) => item.id !== id)), LIFETIME_MS);
}
